import React from 'react';

import iconNotice from '../../assets/notice.svg';
import config from './InformationCard.config';

import './InformationCard.style.less';

const InformationCard = ({ title, description }) => (
  <div className="InformationCard">
    <div className="notice-title" id="text_titleInfo">
      {title.trim()} <img src={iconNotice} alt="" className="info" />
    </div>
    <p id="text_descInfo">{description.trim()}</p>
  </div>
);

InformationCard.propTypes = config.propTypes;
InformationCard.defaultProps = config.defaultProps;
InformationCard.componentDetail = config.componentDetail;
InformationCard.builderConfig = config.builderConfig;

export default InformationCard;
